import SvgIcon from '@/components/SvgIcon/index.vue'// svg component

export default {
  install(app) {
    app.component('svg-icon', SvgIcon)
  }
}
